import { csvReader } from "../../utils/csvReader";
import { EmiData } from "./models/EmiData";

export function getDataPoints() {
    // append the current timestamp to the query argument to bust browser caching
    const currentTimestamp = Date.now().toString();
    return csvReader<EmiData>(`/data-sources/emi/data.csv?t=${currentTimestamp}`);    
}
